module.exports = __webpack_public_path__ + "img/motorbike-rear-left.29954a30.svg";